import React from 'react';
import _ from 'lodash';

import Table from 'components/Table';

import deleteIcon from 'assets/icons/trash.svg';
import {formatDate} from 'utils/datetime';
import {openUrlInNewTab} from 'utils/files';

import './styles.css';

const ProofOfIncomeTable = ({documents, deleteDocument}) => (
  <div className="ProofOfIncomeTable">
    <div className="header">Proof of income documents</div>
    <Table>
      <Table.Header>
        <Table.HeaderItem heading="Filename" className="filename" />
        <Table.HeaderItem heading="Uploaded" className="uploaded" />
        <Table.HeaderItem heading="Uploaded by" className="uploadedBy" />
        <Table.HeaderItem className="more" />
      </Table.Header>
      <Table.Body>
        {!_.isEmpty(documents) &&
          documents.map(doc => (
            <Table.Row key={doc.identifier}>
              <Table.Cell
                className="documentPreview"
                onClick={() => openUrlInNewTab(doc.fileUrl)}>
                {doc.filename}
              </Table.Cell>
              <Table.Cell>{formatDate(doc.createdAt)}</Table.Cell>
              <Table.Cell>{doc.addedBy}</Table.Cell>
              <Table.Cell
                onClick={() =>
                  deleteDocument({
                    documentId: doc.identifier,
                    documentName: doc.filename
                  })
                }>
                <img src={deleteIcon} alt="Delete" />
              </Table.Cell>
            </Table.Row>
          ))}
      </Table.Body>
    </Table>
    <div className="horizontalLine" />
  </div>
);

export default ProofOfIncomeTable;
